import { Component } from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import axios from "axios";

import { appInsights } from "../utils/logHandlers/appInsight";
import { ErrorResponse, userDate } from "../utils";
import { utcDateToUser } from "../utils/DateTime";
import SnackbarUtils from "../utils/SnackbarProvider";

export const ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
export const ERROR_INVALID_SESSION = "sessionInvalidMessage";
export const ERROR_KEY = "REDIRECT_MESSAGE";
export const ERROR_NOT_FOUND = "notFoundMessage";
export const ERROR_PERMISSION_DENIED = "permissionDeniedMessage";
export const ERROR_SESSION_EXPIRED = "sessionExpiredMessage";
export const FORCE_REDIRECT_KEY = "INVALID_SESSION_FORCE_REDIRECT";
export const NOT_FOUND_ERROR_STATUS = 404;
export const REFRESH_TOKEN_EXPIRED_STATUS = 403;
export const UNAUTHORIZED_ERROR_STATUS = 401;

type Methods = "head" | "options" | "put" | "post" | "patch" | "delete" | "get";

class API extends Component {
  static call(method: Methods, url: string, type: any, ...rest: any[]) {
    const req = userDate(rest);
    return axios[method](url, ...req)
      .then((response) => {
        if (type && type == "file") {
          const responseData = utcDateToUser(response);
          return responseData;
        } else {
          const responseData = utcDateToUser(response.data);
          return responseData;
        }
      })
      .catch((err) => {
        if (type && type == "file") {
          return err;
        }
        if (err.response.status === 404) {
          return null;
        }
        if (err.response && err.response.status) {
          if (appInsights !== undefined) {
            appInsights.trackException({
              error: err.response.status,
              severityLevel: SeverityLevel.Error,
            });
          }
        }
        const msg = "Something went wrong!";
        SnackbarUtils.warning(msg);
        ///throw err;//TBD
      });
  }

  static callAPI(method: Methods, url: string, ...rest: any[]) {
    const req = userDate(rest);
    return axios[method](url, ...req)
      .then((response) => {
        const responseData = utcDateToUser(response);
        return responseData;
      })
      .catch((err) => {
        if (err.response && err.response.status) {
          if (appInsights !== undefined) {
            appInsights.trackException({
              error: err.response.status,
              severityLevel: SeverityLevel.Error,
            });
          }
        }
        return ErrorResponse(err.response);
      });
  }

  static getBlob(method: Methods, url: string, header: any) {
    return axios({
      url: url,
      method: method,
      headers: header.headers,
      responseType: "blob",
    })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        if (err.response && err.response.status) {
          if (appInsights !== undefined) {
            appInsights.trackException({
              error: err.response.status,
              severityLevel: SeverityLevel.Error,
            });
          }
        }
        return ErrorResponse(err.response);
      });
  }

  //-------------------------------------------
  static APIResponse(
    method: Methods,
    url: string,
    data?: any[],
    isPostPut?: boolean,
  ) {
    const header = {
      headers: {},
    };
    const fileType = data as any;
    if (fileType && (fileType == "excel" || fileType == "file")) {
      return API.getBlob(method, url, header);
    } else if (isPostPut) {
      return API.call(method, url, "", data, header);
    } else if (method == "get" || method == "delete") {
      return API.call(method, url, data, header);
    } else {
      return API.callAPI(method, url, data, header);
    }
  }
  //-----------------------------------------------
  static APICall(
    method: Methods,
    url: string,
    data?: any[],
    isPostPut?: boolean
  ) {
    return API.APIResponse(method, url, data, isPostPut);
  }

  static getApi(url: string, config?: any) {
    return API.call("get", url, config);
  }

  static get(url: string, type?: any) {
    return API.APICall("get", url, type);
  }

  static post(url: string, data: any) {
    return API.APICall("post", url, data, true);
  }
  static put(url: string, data: any) {
    return API.APICall("put", url, data, true);
  }
  static delete(url: string) {
    return API.APICall("delete", url);
  }
  static putApi(url: string, data: any) {
    return API.APICall("put", url, data);
  }
  static postApi(url: string, data: any) {
    return API.APICall("post", url, data);
  }
}
export default API;
